import requestLog from '@/utils/request-log'

// 提交错误日志
export function PostLog(data) {
  return requestLog({
    url: '/oss-api/log',
    method: 'post',
    data
  })
}

export function GetNotificationUnRead(params) {
  return requestLog({
    url: '/wallet-app-api/walletUserIssue/getUnreadReplies',
    method: 'get',
    params
  })
}
